export const quicklinks = [
  {
    title: "Top Up",
    image: "topup",
    link: "https://telecel.com.gh/personal/mobile/offers/top-up",
  },
  {
    title: "Pay bill",
    image: "Bill Payments",
    link: "https://play.telecel.com.gh/pay",
  },
  {
    title: "Apply for Broadband",
    image: "International",
    link: "https://play.telecel.com.gh/pap/index.php?sid=check",
  },
  {
    title: "Self service",
    image: "selfService",
    link: "https://play.telecel.com.gh/dashboard",
  },
  // {
  //   title: "Careers",
  //   image: "Careers",
  //   link: "me",
  // },
];

export const quicklinksBroadband = [
  {
    title: "Pay bill",
    image: "Bill Payments",
    link: "https://play.telecel.com.gh/pay",
  },
  {
    title: "Self service",
    image: "selfService",
    link: "https://play.telecel.com.gh/dashboard",
  },
  {
    title: "Apply for Broadband",
    image: "International",
    link: "https://play.telecel.com.gh/pap/index.php?sid=check",
  },
  // {
  //   title: "Report a Fault",
  //   image: "Careers",
  //   link: "me",
  // },
];

export const quicklinksBusiness = [
  {
    title: "Pay bill",
    image: "Bill Payments",
    link: "https://play.telecel.com.gh/pay",
  },
  {
    title: "Self service",
    image: "selfService",
    link: "https://play.telecel.com.gh/dashboard",
  },
  // {
  //   title: "Apply for Broadband",
  //   image: "International",
  //   link: "https://play.telecel.com.gh/pap/index.php?sid=check",
  // },
  // {
  //   title: "Report a Fault",
  //   image: "Careers",
  //   link: "me",
  // },
];

export const quicklinksMobile = [
  {
    title: "Top Up",
    image: "topup",
    link: "https://telecel.com.gh/personal/mobile/offers/top-up",
  },
  {
    title: "Buy Bundle",
    image: "bundle",
    link: "https://telecel.com.gh/personal/mobile/offers/bundles/",
  },
  {
    title: "Self service",
    image: "selfService",
    link: "https://play.telecel.com.gh/dashboard",
  },
  // {
  //   title: "Report a Fault",
  //   image: "Careers",
  //   link: "me",
  // },
];

export const quicklinksWholesale = [
  // {
  //   title: "Contact Us",
  //   image: "topup",
  //   link: "/personal/mobile/offers/top-up",
  // },
  {
    title: "Self service",
    image: "selfService",
    link: "https://wholesale.telecel.com.gh/self-service/",
  },
];
